import React from "react";

const StatCard = ({
  title,
  value,
  icon: Icon,
  iconColor = "text-blue-600",
  iconBg = "bg-blue-50",
  description,
  trend,
  trendType = "neutral",
  onClick,
}) => {
  return (
    <div
      onClick={onClick}
      className={`rounded-2xl border border-slate-200 bg-white p-5 transition-all duration-200 hover:shadow-sm ${
        onClick
          ? "cursor-pointer hover:border-slate-300 hover:bg-slate-50/20 active:bg-slate-50"
          : ""
      }`}
    >
      <div className="flex items-center justify-between">
        {/* Icon */}
        {Icon && (
          <div
            className={`
              flex
              h-10
              w-10
              items-center
              justify-center
              rounded-xl
              ${iconBg}
            `}
          >
            <Icon
              size={20}
              strokeWidth={2}
              className={iconColor}
            />
          </div>
        )}
      </div>

      {/* Content */}
      <div className="mt-4 text-left">
        <p className="text-xs font-semibold uppercase tracking-wider text-slate-400">
          {title}
        </p>

        <p className="mt-1 text-2xl font-bold tracking-tight text-slate-800 leading-none">
          {value ?? 0}
        </p>

        {/* Subtext / Trend */}
        {(trend || description) && (
          <div className="mt-2.5 flex items-center gap-1 text-[11px]">
            {trend && (
              <span
                className={`font-semibold ${
                  trendType === "positive"
                    ? "text-emerald-600"
                    : trendType === "negative"
                      ? "text-red-600"
                      : "text-slate-500"
                }`}
              >
                {trend}
              </span>
            )}
            {description && (
              <span className="text-slate-400 font-medium">
                {description}
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default StatCard;